import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import { getProfileModules } from '../../config/profilesConfig';
import '../../styles/Layout.css';

function Layout({ user, onLogout, onCambiarPassword, children }) {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Actualizar titulo de la pagina segun el modulo activo
  useEffect(() => {
    const modules = getProfileModules(user.role, user.tipoUsuario);
    const currentModule = modules.find(m => m.path === location.pathname);
    const moduleLabel = currentModule ? currentModule.label : 'Inicio';
    document.title = `${moduleLabel} | UAcademiK`;
  }, [location.pathname, user.role, user.tipoUsuario]);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="admin-layout">
      {/* Banner de sesion impersonada */}
      {user.isImpersonated && (
        <div className="impersonate-banner">
          <span className="impersonate-icon">👤</span>
          <span className="impersonate-text">
            Sesión como <strong>{user.role}</strong> en <strong>{user.colegioNombre}</strong>
            {user.impersonatedBy && <span> (iniciada por {user.impersonatedBy})</span>}
          </span>
          <button
            className="impersonate-close"
            onClick={onLogout}
            title="Cerrar sesion de impersonation"
          >
            Cerrar sesion
          </button>
        </div>
      )}
      <Navbar user={user} onLogout={onLogout} onCambiarPassword={onCambiarPassword} toggleSidebar={toggleSidebar} />
      <div className="layout-container">
        <Sidebar
          isOpen={sidebarOpen}
          toggleSidebar={toggleSidebar}
          user={user}
        />
        <main className="main-content">
          {children}
        </main>
      </div>
    </div>
  );
}

export default Layout;
